import React, { useCallback, useState } from "react";
import TableComponent from "./components/Table";
import FormComponent from "./components/Form";
import { PageMode } from "utils/constant";
import { useSelector } from "react-redux";

const VectorControllResultsReport = () => {
  const [pageMode, setPageMode] = useState(PageMode.view);

  return (
    <div className="dashboard-wrapper">
      <h1 className="page-title">Laporan Hasil Pengendalian Vektor</h1>

      {pageMode === PageMode.view && (
        <TableComponent changeMode={setPageMode} />
      )}
      {(pageMode === PageMode.add || pageMode === PageMode.edit) && (
        <FormComponent pageMode={pageMode} changeMode={setPageMode} />
      )}
    </div>
  );
};

export default VectorControllResultsReport;
